// Default settings for our .validator plugin
// https://jqueryvalidation.org/reference/
import $ from 'jquery';
import 'vendor/validate/dist/jquery.validate';

// taken from vendor/validate/dist/additional-methods.js, instead of including the entire file
$.validator.addMethod('phoneUS', function (phone_number, element) {
  phone_number = phone_number.replace( /\s+/g, '');
  return this.optional( element ) || phone_number.length > 9 &&
    phone_number.match( /^(\+?1-?)?(\([2-9]([02-9]\d|1[02-9])\)|[2-9]([02-9]\d|1[02-9]))-?[2-9]([02-9]\d|1[02-9])-?\d{4}$/ );
}, 'Please specify a valid phone number' );

$.validator.addMethod( 'zipcodeUS', function (value, element) {
  return this.optional(element) || /^\d{5}(-\d{4})?$/.test( value );
}, 'The specified US ZIP Code is invalid' );

// set BAT defaults
$.validator.setDefaults({
  debug: true,
  errorClass: 'ui-state-error',
  validClass: 'ui-state-valid',
  errorPlacement: function (error, element) {
    // needed to to prevent inline labels from being output
    return;
  },
  highlight: function (element, errorClass, validClass) {
    var $el = $(element);
    if ($el.is('select')) {
      $el.prev('div.dk-select').addClass(errorClass);
    }
    $el.addClass(errorClass);
  },
  unhighlight: function (element, errorClass, validClass) {
    var $el = $(element);
    if ($el.is('select')) {
      $el.prev('div.dk-select').removeClass(errorClass);
    }
    $el.removeClass(errorClass);
  },
});
